<template>
  <div>

    <VTextField
      v-model="internalValue"
      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
      :type="show ? 'text' : 'password'"
      outlined
      label="Password"
      name="password"
      @click:append="show = !show"
    />

      <BaseBtn
              :disabled="!internalValue"
              :loading="isLoading"
              class="text-capitalize ma-0"
              depressed
              @click="submit"
              block large
      >
          Log In
      </BaseBtn>
  </div>
</template>

<script>
  // Utilities
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex'
  import BaseBtn from '@/components/BaseBtn'

  export default {
    components: { BaseBtn },
    data: () => ({
      show: false
    }),

    computed: {
      ...mapState([
        'email',
        'username',
        'password',
        'isLoading'
      ]),
      internalValue: {
        get () {
          return this.$store.state.password
        },
        set (val) {
          this.setPassword(val)
        }
      }
    },
    mounted(){

    },
    methods: {
      ...mapActions('cognito', ['signInUser', 'forgotPassword']),
      ...mapMutations([
        'setEmail',
        'setPassword',
        'setIsLoading',
        'setSnackbar'
      ]),
      submit () {
        let em = this;
        let uname = ''
        if(this.username.includes('@')){
          uname = this.username.toLowerCase().trim()
        } else {
          uname = '+1'+this.username.trim()
        }
        this.hasError = false
        this.setIsLoading(true)
        this.signInUser({
          username: uname,
          password: this.password.trim()
        }).then(() => {
            this.setSnackbar({
              type: 'success',
              msg: `Successfully signed in user ${this.email}`
            })
            this.setEmail('')
            this.setPassword('')
            this.$store.dispatch('refreshAuth')
            //this.$router.push('/')
          }).catch(res => {
            console.log(res)
            if(res.code==='UserNotFoundException'){
              this.$router.push('/auth/signup')
            }
            this.setSnackbar({
              type: 'error',
              msg: res.message
            })
          }).finally(() => {
            window.localStorage.removeItem('username')
            this.setIsLoading(false)

          })
      }
    }
  }
</script>

<style lang="scss">
.v-chip__content {
  cursor: pointer !important;
}
</style>
